export default __webpack_public_path__ + "static/media/rowing-blazers.ded094b9.png";